<template>
  <v-container fluid>
    <PageHeading
      :text="'Конфигурации SEO'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-seo-config-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать конфигурацию
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridSeoConfigs ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridSeoConfigs from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageSeoConfigs',
  components: {
    PageHeading,
    GridSeoConfigs
  },
  metaInfo () {
    return {
      title: 'Конфигурации SEO'
    }
  },
  mixins: [gridPageInterface]
}
</script>
